import { render, staticRenderFns } from "./PageCol2.vue?vue&type=template&id=064f13c8&scoped=true&"
import script from "./PageCol2.vue?vue&type=script&lang=js&"
export * from "./PageCol2.vue?vue&type=script&lang=js&"
import style0 from "./PageCol2.vue?vue&type=style&index=0&id=064f13c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064f13c8",
  null
  
)

export default component.exports